import { render } from "./TabTracker.vue?vue&type=template&id=7379965e"
import script from "./TabTracker.vue?vue&type=script&lang=js"
export * from "./TabTracker.vue?vue&type=script&lang=js"

import "./TabTracker.vue?vue&type=style&index=0&id=7379965e&lang=css"

import exportComponent from "/Users/vaninamikova/Documents/Learning/Old Projects/tab-tracker/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__